import { BaseModel } from '../../_base/crud';

export class Link extends BaseModel {
  id: number;
  name: string;
  type: string;
  value: string;
  link_group_id: any;
  link_group: any;
}
